import { combineReducers } from 'redux';
import { creditAppReducer } from './creditAppReducer';
import { voReducer } from './voReducer';
import { vpReducer } from './vpReducer';
import { accountReducer } from './accountReducer';
import { accountRepReducer } from './accountRepReducer';
import { userProfileReducer } from './userProfileReducer';
import { loadingReducer } from './loadingReducer';
import { refetchReducer } from './refetchReducer';
import { relatedUsersReducer } from './relatedUsersReducer';
import { chatReducer } from './chatReducer';
import { lpReducer } from './lpReducer';
import { disabledLenderProfilesReducer } from './disabledLenderProfilesReducer';
import { setupWizardReducer } from './setupWizardReducer';
import { setupFastTrackModalReducer } from './setupFastTrackModalReducer';
import { creditSubmissionReducer } from './creditSubmissionReducer';
import { chatV2Rducer } from './chatv2Reducer';
import { modalsReducer } from './modalsReducer';
import { portalConfigurationReducer } from './portalConfigurationReducer';
import { notificationsReducer } from '../modules/notification';
import { deskingReducer } from '../modules/desking';
import { aftermarketMenuConstructorReducer } from '../modules/aftermarketMenuConstructor';
import { aftermarketPartnerReducer } from 'modules/aftermarket/partner';
import { prescreenReducer } from '../modules/prescreen';
import { insuranceReducer } from '../modules/vendorOpportunity';
import { portalNotificationsReducer } from './portalNotificationsReducer';

// Migrated from LP
import { creditSubmission } from './creditSubmission';
import { documents } from './documents';
import { lenderProfile } from './lenderProfile';

export const rootReducer = combineReducers({
  account: accountReducer,
  accountRep: accountRepReducer,
  userProfile: userProfileReducer,
  vo: voReducer,
  vp: vpReducer,
  lp: lpReducer,
  disabledLenderProfiles: disabledLenderProfilesReducer,
  creditApp: creditAppReducer,
  relatedUsers: relatedUsersReducer,
  refetch: refetchReducer,
  loading: loadingReducer,
  chat: chatReducer,
  setupWizard: setupWizardReducer,
  setupFastTrack: setupFastTrackModalReducer,
  creditSubmissions: creditSubmissionReducer,
  chatV2: chatV2Rducer,
  portalConfiguration: portalConfigurationReducer,
  portalNotifications: portalNotificationsReducer,

  // Migrated from LP
  cs: creditSubmission,
  docs: documents,
  lenderProfile: lenderProfile,

  modals: modalsReducer,
  desking: deskingReducer,
  aftermarketMenuConstructor: aftermarketMenuConstructorReducer,
  aftermarketPartner: aftermarketPartnerReducer,
  notifications: notificationsReducer,
  prescreen: prescreenReducer,
  insurance: insuranceReducer,
});
